
let accordionHeaders = document.querySelectorAll('.nh-accordion-section h2');
if (accordionHeaders.length > 1){
  [].forEach.call(accordionHeaders, function( acc ) {

    acc.addEventListener('click', (e) => {

      e.preventDefault();
      let group = acc.parentNode.parentNode.querySelector(".nh-accordion");
      let content = group?.querySelector(".inner");
      let height = content.offsetHeight;

      let current = document.querySelector(".nh-accordion.current");

      if (current != null && current !== group) {
        current.classList.remove("current");
        current.parentNode.querySelector(".nh-accordion-title").classList.remove("open");
        current.style.height = 0 + "px";
      }

      let currentHeight = group.offsetHeight;

      if (currentHeight == 0) {
        group.style.height = height + "px";
        group.classList.add("current");
        acc.parentNode.classList.add("open");
      } else {
        group.style.height = 0 + "px";
        group.classList.remove("current");
        acc.parentNode.classList.remove("open");
      }

    });
  });
}


function positionImages(){
  const windowWidth = window.innerWidth;

  let imageDiv = document.querySelector('.nh-product .product-img');
  let infoDiv = document.querySelector('.nh-product .product-info');
  let productStory= document.querySelector('.nh-product-story');
  if ( imageDiv != null ){
    if ( windowWidth < 1081 ){
      
      if ( productStory != null ){
        infoDiv.before(imageDiv);
        infoDiv.before(productStory);
      } else {
        infoDiv.before(imageDiv);  
      }
    } else {
      infoDiv.after(imageDiv);
      if ( productStory != null ){
        imageDiv.after(productStory);
      }
    }
  }
}

positionImages();

addEventListener("resize", (event) => {

  positionImages();

});

let productSliders = document.querySelectorAll('.nh-product-swiper');
let x=0;
[].forEach.call(productSliders, function( slider ) {

  const swiper = new Swiper('.nh-product-swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      speed: 600,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {}
  });


  let paginationDiv = slider.parentNode.querySelector('.swiper-pagination');
  let swp = null;

  if ( Array.isArray(swiper) ){
    swp = swiper[x];
  } else {
    swp = swiper;
  }
  let slideNum = swp.slides.length;
  if ( paginationDiv != null && slideNum > 1){

    let pagination = '';

    for ( let x=1; x<=slideNum; x++ ){
      let active = '';
      let slideIndex = x - 1;
      let slideNum = '';
      if ( x < 10 ){
        slideNum = '0'+x;
      } else {
        slideNum = x;
      }

      if ( x == 1 ){
          active = ' class="active"';
      }

      pagination += '<button type="button"'+active+' aria-label="Go to Slide '+x+'" data-index="'+slideIndex+'">'+slideNum+'</button>';
    }

    paginationDiv.innerHTML = pagination;


    let paginationButtons = paginationDiv.querySelectorAll('button');
    if ( paginationButtons != null ){
      [].forEach.call(paginationButtons, function( btn ) {
        btn.addEventListener('click', () => {
          console.log('clicked page button');
          let slideIndex = btn.getAttribute('data-index');
          swp.slideToLoop(slideIndex, 600, false);

        })

      });



      swp.on('realIndexChange', function () {
        let activeButton = paginationDiv.querySelector('button.active');
        if ( activeButton != null ){
          activeButton.classList.remove('active');
        }

        paginationButtons[swp.realIndex].classList.add('active');

        let newSlideVideo = swp.slides[swp.activeIndex].querySelector('video');
        newSlideVideo?.play();

        let oldSlideVideo = swp.slides[swp.previousIndex].querySelector('video');
        oldSlideVideo?.pause();

      });

    }
  }

    x++;

});


let options = document.querySelectorAll('.nh-option input');

if ( options.length == 0 ){

  let defaultImageSet = document.querySelector('.nh-product-image-holder');


  if ( defaultImageSet != null ){
      imagesLoaded( defaultImageSet, () => {
          defaultImageSet.classList.add('active');
      });
  }
}

let productVideos = document.querySelector('.nh-video-holder');
if ( productVideos != null ){

}

